var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var WsUrl = ResolveUrl("~/LoanData.asmx");
var OldApiReadOnlySession = "?ReadonlySession=true";
var CompanyPayExpirationTimingFactory = (function () {
    function CompanyPayExpirationTimingFactory($http) {
        this.$http = $http;
    }
    CompanyPayExpirationTimingFactory.prototype.getAll = function () {
        return this.$http.post(WsUrl + "/GetCompanyPayExpirationTimings", {});
    };
    CompanyPayExpirationTimingFactory.$inject = ["$http"];
    return CompanyPayExpirationTimingFactory;
}());
var CompanyPayExpirationFactory = (function () {
    function CompanyPayExpirationFactory($http) {
        this.$http = $http;
    }
    CompanyPayExpirationFactory.prototype.getByID = function (companyPayExpirationID) {
        return this.$http.post(WsUrl + "/GetCompanyPayExpirationByID", {
            CompanyPayExpirationID: companyPayExpirationID,
        });
    };
    CompanyPayExpirationFactory.$inject = ["$http"];
    return CompanyPayExpirationFactory;
}());
var CompanyBulkheadFactory = (function () {
    function CompanyBulkheadFactory($http, csApiUrl) {
        this.$http = $http;
        this.csApiUrl = csApiUrl;
    }
    CompanyBulkheadFactory.prototype.isBulkheadActive = function (internalCode) {
        return this.$http.get(this.csApiUrl + "/company-bulkheads/" + internalCode);
    };
    CompanyBulkheadFactory.$inject = ["$http", "csApiUrl"];
    return CompanyBulkheadFactory;
}());
var BranchFactory = (function () {
    function BranchFactory($http, csApiUrl) {
        this.$http = $http;
        this.csApiUrl = csApiUrl;
    }
    BranchFactory.prototype.get = function (regID, active) {
        return this.$http.post(WsUrl + "/GetBranchInfobyCompanyIDDirectory", {
            RegionID: regID,
            Active: active,
            SearchBy: "",
        });
    };
    BranchFactory.prototype.getBranchByBrID = function (brID) {
        return this.$http.post(WsUrl + "/GetBranchByBrID", {
            BrID: brID,
        });
    };
    BranchFactory.prototype.getMasterBranches = function (regID, active) {
        return this.$http.get(this.csApiUrl + "/branches/master-branches?regionID=" + regID + "&active=" + active + "&branchType=B");
    };
    BranchFactory.prototype.getBranches = function (regID) {
        return this.$http.post(WsUrl + "/GetBranchInfo" + OldApiReadOnlySession, {
            RegionID: regID,
            BrInclSubs: false,
            Active: 1,
            AccessLevelType: "Default",
        });
    };
    BranchFactory.prototype.getBranchDDL = function () {
        return this.$http.post(WsUrl + "/GetBranchDDL", {
            ProductionBr: 2,
            RegionBr: 2,
            ExecutiveBr: 2,
            ActiveBr: 1,
            AccessOverride: 0,
        });
    };
    BranchFactory.prototype.getCurrentBranch = function () {
        return this.$http.post(WsUrl + "/GetCurrentBranchInfo", {});
    };
    BranchFactory.prototype.getBranchByLOC = function (loc) {
        return this.$http.post(WsUrl + "/GetBranchInfoByLOC", {
            AccessLevelType: "Default",
            RegID: 0,
            Loc: loc,
        });
    };
    BranchFactory.prototype.getBranchDetails = function (loc) {
        return this.$http.get(this.csApiUrl + "/branches/branch-by-loc/" + encodeURIComponent(loc));
    };
    BranchFactory.$inject = ["$http", "csApiUrl"];
    return BranchFactory;
}());
var EmployeeFactory = (function () {
    function EmployeeFactory($http, csApiUrl) {
        this.$http = $http;
        this.csApiUrl = csApiUrl;
    }
    EmployeeFactory.prototype.get = function (brID, active, searchBy, sortByActiveStatus, allowOwnTransactions) {
        if (sortByActiveStatus === void 0) { sortByActiveStatus = false; }
        if (allowOwnTransactions === void 0) { allowOwnTransactions = true; }
        return this.$http.post(WsUrl + "/GetEmployeeInfoForDirectory" + OldApiReadOnlySession, {
            BranchID: brID,
            Active: active,
            SearchBy: searchBy,
            ScanForPictures: false,
            SortByActiveStatus: sortByActiveStatus,
            AllowOwnTransactions: typeof allowOwnTransactions === "undefined" ? true : allowOwnTransactions
        });
    };
    EmployeeFactory.prototype.getEmployeesNearlyAllOptions = function (regID, brID, empID, showLoc, active, empTypeOpt, empAccessLevel, brInclSubs, accessLevelType, restrictToUser) {
        return this.$http.post(WsUrl + "/GetEmployeesNearlyAllOptions", {
            RegionID: regID,
            BranchID: brID,
            EmployeeID: empID,
            ShowLOC: showLoc,
            Active: active,
            EmpTypeOpt: empTypeOpt,
            EmpAccessLevel: empAccessLevel,
            BrInclSubs: typeof brInclSubs === "undefined" || !brInclSubs ? null : brInclSubs,
            AccessLevelType: accessLevelType,
            RestrictToUser: restrictToUser,
        });
    };
    EmployeeFactory.prototype.getEmployees = function (regID, brID, empOptType, active, brInclSubs, allowOwnTransactions) {
        return this.$http.post(WsUrl + "/GetEmployees", {
            RegionID: regID,
            BranchID: brID,
            AccessLevelType: "Default",
            EmpOptType: empOptType,
            Active: active,
            BrInclSubs: typeof brInclSubs === "undefined" || !brInclSubs ? null : brInclSubs,
            AllowOwnTransactions: typeof allowOwnTransactions === "undefined" ? true : allowOwnTransactions
        });
    };
    EmployeeFactory.prototype.getDetail = function (empID) {
        return this.$http.get(this.csApiUrl + "/employees/details/" + empID);
    };
    EmployeeFactory.prototype.getEmployeeByEmpID = function (empID) {
        return this.$http.post(WsUrl + "/GetEmployeeInfoByID", {
            RegionID: 0,
            BranchID: 0,
            EmpID: empID,
            AccessLevelType: "Default",
        });
    };
    EmployeeFactory.prototype.save = function (employee, regions, branches) {
        if (employee.IsNew) {
            return this.$http.post(WsUrl + "/InsertNewEmployeeInfo", {
                EmployeeInfo: employee,
                RegionList: regions,
                BranchList: branches,
            });
        }
        else {
            return this.$http.post(WsUrl + "/UpdateEmployeeInfo", {
                EmployeeInfo: employee,
                RegionList: regions,
                BranchList: branches,
            });
        }
    };
    EmployeeFactory.prototype.clearLoginLocked = function (empID) {
        return this.$http.post(WsUrl + "/ClearLoginLocked", {
            EmployeeID: empID,
        });
    };
    EmployeeFactory.prototype.GetVerifyFileNumberUnique = function (employee) {
        return this.$http.post(WsUrl + "/GetIsFileNumberUnique", {
            EmployeeID: employee.empID,
            FileNo: employee.fileNo,
        });
    };
    EmployeeFactory.prototype.GetVerifyFileNumberSecondaryUnique = function (employee) {
        return this.$http.post(WsUrl + "/GetIsFileNumberUnique", {
            EmployeeID: employee.empID,
            FileNo: employee.fileNoSecondary,
        });
    };
    EmployeeFactory.prototype.GetVerifyEmailUnique = function (employee) {
        return this.$http.post(WsUrl + "/GetIsEmailUnique", {
            EmployeeID: employee.empID,
            Email: employee.email,
        });
    };
    EmployeeFactory.prototype.GetVerifyEmailSecondaryUnique = function (employee) {
        return this.$http.post(WsUrl + "/GetIsEmailUnique", {
            EmployeeID: employee.empID,
            Email: employee.emailSecondary,
        });
    };
    EmployeeFactory.prototype.GetEmployeeValidation = function (employee) {
        return this.$http.post(WsUrl + "/GetEmployeeValidation", {
            EmployeeID: employee.empID,
            FileNo: employee.fileNo,
            Email: employee.email,
            FileNoSecondary: employee.fileNoSecondary,
            EmailSecondary: employee.emailSecondary,
        });
    };
    EmployeeFactory.$inject = ["$http", "csApiUrl"];
    return EmployeeFactory;
}());
var LoanSourceFactory = (function () {
    function LoanSourceFactory($http, csApiUrl) {
        this.$http = $http;
        this.csApiUrl = csApiUrl;
    }
    LoanSourceFactory.prototype.get = function () {
        return this.$http.post(WsUrl + "/GetLeadSources", {
            leadSourceID: 0,
        });
    };
    LoanSourceFactory.prototype.getActive = function () {
        return this.$http.get(this.csApiUrl + "/lead-sources/active");
    };
    LoanSourceFactory.prototype.getApi = function () {
        return this.$http.get(this.csApiUrl + "/lead-sources");
    };
    LoanSourceFactory.prototype.getActiveApi = function () {
        return this.$http.get(this.csApiUrl + "/lead-sources/active");
    };
    LoanSourceFactory.prototype.save = function (ls) {
        return this.$http.post(WsUrl + "/SaveLeadSource", {
            ls: ls,
        });
    };
    LoanSourceFactory.prototype.update = function (ls) {
        return this.$http.post(WsUrl + "/UpdateLeadSource", {
            ls: ls,
        });
    };
    LoanSourceFactory.prototype.delete = function (id) {
        return this.$http.post(WsUrl + "/DeleteLeadSource", {
            id: id,
        });
    };
    LoanSourceFactory.prototype.deleteApi = function (id) {
        return this.$http.delete(this.csApiUrl + "/lead-sources/" + id);
    };
    LoanSourceFactory.prototype.getUtilizedLeadSources = function () {
        return this.$http.post(WsUrl + "/GetUtilizedLeadSources", {});
    };
    LoanSourceFactory.prototype.getEmployeeLeadSources = function () {
        return this.$http.post(WsUrl + "/GetEmployeeLeadSources", {});
    };
    LoanSourceFactory.prototype.getLeadSourceSubstitute = function () {
        return this.$http.post(WsUrl + "/GetLeadSourceSubstitute", {});
    };
    LoanSourceFactory.prototype.insertLeadSourceSubstitute = function (ls) {
        return this.$http.post(WsUrl + "/InsertLeadSourceSubstitute", {
            ls: ls,
        });
    };
    LoanSourceFactory.prototype.updateLeadSourceSubstitute = function (ls) {
        return this.$http.post(WsUrl + "/UpdateLeadSourceSubstitute", {
            ls: ls,
        });
    };
    LoanSourceFactory.prototype.deleteLeadSourceSubstitute = function (leadSourceSubID) {
        return this.$http.post(WsUrl + "/DeleteLeadSourceSubstitute", {
            leadSourceSubID: leadSourceSubID,
        });
    };
    LoanSourceFactory.$inject = ["$http", "csApiUrl"];
    return LoanSourceFactory;
}());
var LoanTypeFactory = (function () {
    function LoanTypeFactory($http, $q) {
        this.$http = $http;
        this.$q = $q;
    }
    LoanTypeFactory.prototype.onSuccess_get = function (response) {
        if (typeof response.data.d === "object") {
            return response.data.d;
        }
        else {
            return this.$q.reject(response.data.d);
        }
    };
    LoanTypeFactory.prototype.onFailure_get = function (response) {
        return this.$q.reject(response);
    };
    LoanTypeFactory.prototype.get = function () {
        return this.$http
            .post(WsUrl + "/GetLoanType", {})
            .then(this.onSuccess_get, this.onFailure_get);
    };
    LoanTypeFactory.$inject = ["$http", "$q"];
    return LoanTypeFactory;
}());
var LoanChannelFactory = (function () {
    function LoanChannelFactory($http) {
        this.$http = $http;
    }
    LoanChannelFactory.prototype.get = function () {
        return this.$http.post(WsUrl + "/GetLoanChannels", {});
    };
    LoanChannelFactory.$inject = ["$http"];
    return LoanChannelFactory;
}());
var CurrentUserFactory = (function () {
    function CurrentUserFactory($http, $q, csApiUrl) {
        this.$http = $http;
        this.$q = $q;
        this.csApiUrl = csApiUrl;
    }
    CurrentUserFactory.prototype.IsImpersonating = function () {
        return this.$http.post(WsUrl + "/GetIsUserImpersonating", {});
    };
    CurrentUserFactory.prototype.hasAccessToEmp = function (EmpID) {
        return this.$http.post(WsUrl + "/GetHasAccessToEmployee", {
            EmpID: EmpID,
        });
    };
    CurrentUserFactory.prototype.hasAccessToBranch = function (BrID) {
        return this.$http.get(this.csApiUrl + "/branches/has-access-to-branch/" + BrID);
    };
    CurrentUserFactory.prototype.onFailure_get = function (response) {
        return this.$q.reject(response);
    };
    CurrentUserFactory.prototype.onSuccess_get = function (response) {
        if (typeof response.data.d === "object") {
            return response.data.d;
        }
        else {
            return this.$q.reject(response.data.d);
        }
    };
    CurrentUserFactory.prototype.get = function () {
        return this.$http
            .get(this.csApiUrl + "/employees/user/legacy")
            .then(this.onSuccess_get, this.onFailure_get);
    };
    CurrentUserFactory.prototype.onSuccess_getPageAccess = function (response) {
        if (typeof response.data.d === "boolean") {
            return response.data.d;
        }
        else {
            return this.$q.reject(response.data.d);
        }
    };
    CurrentUserFactory.prototype.getPageAccess = function (type) {
        switch (type) {
            case "scorecards":
                return this.$http
                    .post(WsUrl + "/CheckPageAccessScorecard", {})
                    .then(this.onSuccess_getPageAccess, this.onFailure_get);
            case "watchlist":
                return this.$http
                    .post(WsUrl + "/CheckPageAccessWatchList", {})
                    .then(this.onSuccess_getPageAccess, this.onFailure_get);
            case "marketing":
                return this.$http
                    .post(WsUrl + "/CheckPageAccessMarketing" + OldApiReadOnlySession, {})
                    .then(this.onSuccess_getPageAccess, this.onFailure_get);
            default:
                return this.$q.reject("Not a valid PageAccess type.");
        }
    };
    CurrentUserFactory.$inject = ["$http", "$q", "csApiUrl"];
    return CurrentUserFactory;
}());
var CompanyFactory = (function () {
    function CompanyFactory($http, csApiUrl) {
        this.$http = $http;
        this.csApiUrl = csApiUrl;
    }
    CompanyFactory.prototype.get = function () {
        return this.$http.get(this.csApiUrl + "/company/for-user");
    };
    CompanyFactory.prototype.getCompany = function (CompanyID) {
        return this.$http.post(WsUrl + "/GetCompany", {
            CompanyID: CompanyID,
        });
    };
    CompanyFactory.prototype.getCurrentCompanyID = function () {
        return this.$http.post(WsUrl + "/GetCurrentCompanyID", {});
    };
    CompanyFactory.prototype.getAllCompany = function (Active) {
        return this.$http.post(WsUrl + "/GetAllCompanies", {
            Active: Active,
        });
    };
    CompanyFactory.prototype.getCompanyParam = function (paramName) {
        return this.$http.post(WsUrl + "/GetCompanyParam" + OldApiReadOnlySession, {
            paramName: paramName,
        });
    };
    CompanyFactory.prototype.getCompanyParamByNameCompanyID = function (companyID, paramName) {
        return this.$http.post(WsUrl + "/GetCompanyParamByNameCompanyID", {
            companyId: companyID,
            paramName: paramName,
        });
    };
    CompanyFactory.prototype.getCompanyLtDataSource = function () {
        return this.$http.post(WsUrl + "/GetCompanyLtDataSource", {});
    };
    CompanyFactory.prototype.save = function (Company) {
        return this.$http.post(WsUrl + "/SaveCompany", {
            Company: Company,
        });
    };
    CompanyFactory.prototype.saveCompanyParams = function (companyID, paramValue, paramName) {
        return this.$http.post(WsUrl + "/UpdateInsertCompanyParams", {
            CompanyID: companyID,
            ParamValue: paramValue,
            ParamName: paramName,
        });
    };
    CompanyFactory.prototype.getCompanyValidation = function (company) {
        return this.$http.post(WsUrl + "/GetCompanyValidation", {
            CompanyID: company.CompanyID,
            CompanyShortName: company.CompanyShortName,
            CompanyFullName: company.CompanyFullName,
        });
    };
    CompanyFactory.prototype.getMenuItems = function () {
        return this.$http.post(WsUrl + "/GetTopMenuItems", {});
    };
    CompanyFactory.prototype.deleteMenuItem = function (Item) {
        return this.$http.post(WsUrl + "/DeleteTopMenuItem", {
            Item: Item,
        });
    };
    CompanyFactory.prototype.saveMenuItems = function (Items) {
        return this.$http.post(WsUrl + "/SaveTopMenuItems", {
            Items: Items,
        });
    };
    CompanyFactory.prototype.getCompanyLockDownStatus = function () {
        return this.$http.post(WsUrl + "/GetCompanyLockDownStatus", {});
    };
    CompanyFactory.prototype.getCanDeleteLoan = function (loanID) {
        return this.$http.post(this.csApiUrl + "/loans/can-delete-loan/" + loanID.toString(), {});
    };
    CompanyFactory.prototype.runDeleteLoan = function (loanID, loanNo) {
        return this.$http.post(this.csApiUrl + "/loans/delete-loan/" + loanID.toString() + "/" + loanNo, {});
    };
    CompanyFactory.$inject = ["$http", "csApiUrl"];
    return CompanyFactory;
}());
var PayrollPeriodFactory = (function () {
    function PayrollPeriodFactory($http, csApiUrl) {
        this.$http = $http;
        this.csApiUrl = csApiUrl;
    }
    PayrollPeriodFactory.prototype.getPayrollPeriod = function (payrollID) {
        return this.$http.post(WsUrl + "/GetPayrollPeriod", {
            PayrollID: payrollID,
        });
    };
    PayrollPeriodFactory.prototype.save = function (payrollPeriod) {
        return this.$http.post(WsUrl + "/SavePayrollPeriod", {
            PayrollPeriod: payrollPeriod,
        });
    };
    PayrollPeriodFactory.prototype.getPayrollByWindow = function (pastCount, futureCount, includeCurrent, includeLastLocked, payCalendarId) {
        return this.$http.post(WsUrl + "/SelectPayrollByPastFutureWindow", {
            PastCount: pastCount,
            FutureCount: futureCount,
            IncludeCurrent: typeof includeCurrent === "undefined" || !includeCurrent
                ? null
                : includeCurrent,
            IncludeLastLocked: typeof includeLastLocked === "undefined" || !includeLastLocked
                ? null
                : includeLastLocked,
            PayCalendarID: typeof payCalendarId === "undefined"
                ? 0
                : payCalendarId,
        });
    };
    PayrollPeriodFactory.prototype.getPastPayrollPeriods = function (payCalendarID) {
        return this.$http.post(WsUrl + "/GetPastPayrollPeriods", {
            PayCalendarID: payCalendarID,
        });
    };
    PayrollPeriodFactory.prototype.getPayrollsUsingPullVar = function (pullVar) {
        return this.$http.post(WsUrl + "/GetPayrollsUsingPullVar", {
            PullVar: pullVar,
        });
    };
    PayrollPeriodFactory.prototype.getPayrollPeriodsCurrentPayDate = function () {
        return this.$http.post(WsUrl + "/GetPayrollPeriodsCurrentPayDate", {});
    };
    PayrollPeriodFactory.prototype.getPayrollPeriodNext = function () {
        return this.$http.post(WsUrl + "/GetPayrollPeriodNext", {});
    };
    PayrollPeriodFactory.prototype.getPayrollPeriodsLastWindow = function () {
        return this.$http.post(WsUrl + "/GetPayrollPeriodsLastWindow", {});
    };
    PayrollPeriodFactory.prototype.getPayDateThis = function () {
        return this.$http.post(WsUrl + "/GetPayDateThis", {});
    };
    PayrollPeriodFactory.prototype.getPayDateThisOffset = function (offset, payCalendarID) {
        return this.$http.post(WsUrl + "/GetPayDateThisOffset?ReadonlySession=true", { offset: offset, payCalendarID: payCalendarID });
    };
    PayrollPeriodFactory.prototype.getLastLockedPayrollPeriod = function () {
        return this.$http.get(this.csApiUrl + "/payroll-periods/last-locked-payroll-period", {});
    };
    PayrollPeriodFactory.prototype.unlockPayrollPeriod = function (payrollId) {
        return this.$http.post(this.csApiUrl + "/payroll-periods/unlock-period", payrollId);
    };
    PayrollPeriodFactory.$inject = ["$http", "csApiUrl"];
    return PayrollPeriodFactory;
}());
var AdjTypeFactory = (function () {
    function AdjTypeFactory($http) {
        this.$http = $http;
    }
    AdjTypeFactory.prototype.getAllActiveManualAdjTypes = function (showDiscrBon, ShowCompensationSetting) {
        return this.$http.post(WsUrl + "/GetAdjTypesByCompany", {
            ViewType: "manual",
            AdjTypeID: 0,
            SysControl: 0,
            Active: 1,
            ShowBonusDiscr: showDiscrBon,
            ShowCompensationSetting: ShowCompensationSetting,
        });
    };
    AdjTypeFactory.prototype.getAllActiveOverrideAdjTypes = function () {
        return this.$http.post(WsUrl + "/GetAdjTypesByCompany", {
            ViewType: "override",
            AdjTypeID: 0,
            SysControl: 1,
            Active: 1,
            ShowBonusDiscr: false,
            ShowCompensationSetting: "ALL",
        });
    };
    AdjTypeFactory.prototype.getManualAdjType = function (adjTypeID, showDiscrBon, ShowCompensationSetting) {
        return this.$http.post(WsUrl + "/GetAdjTypesByCompany", {
            ViewType: "manual",
            AdjTypeID: adjTypeID,
            SysControl: 0,
            Active: 2,
            ShowBonusDiscr: showDiscrBon,
            ShowCompensationSetting: ShowCompensationSetting,
        });
    };
    AdjTypeFactory.prototype.getOverrideAdjType = function (adjTypeID) {
        return this.$http.post(WsUrl + "/GetAdjTypesByCompany", {
            ViewType: "override",
            AdjTypeID: adjTypeID,
            SysControl: 1,
            Active: 2,
            ShowBonusDiscr: false,
            ShowCompensationSetting: "ALL",
        });
    };
    AdjTypeFactory.prototype.getAllOverrideAdjTypes = function () {
        return this.$http.post(WsUrl + "/GetAdjTypesByCompany", {
            ViewType: "override",
            AdjTypeID: 0,
            SysControl: 1,
            Active: 2,
            ShowBonusDiscr: false,
            ShowCompensationSetting: "ALL",
        });
    };
    AdjTypeFactory.prototype.getAllManualAdjTypes = function (showDiscrBon, ShowCompensationSetting) {
        return this.$http.post(WsUrl + "/GetAdjTypesByCompany", {
            ViewType: "manual",
            AdjTypeID: 0,
            SysControl: 0,
            Active: 2,
            ShowBonusDiscr: showDiscrBon,
            ShowCompensationSetting: ShowCompensationSetting,
        });
    };
    AdjTypeFactory.prototype.getCompanyAdjTypes = function (viewType, sysControl, active) {
        return this.$http.post(WsUrl + "/GetCompanyAdjTypes", {
            ViewType: viewType,
            SysControl: sysControl,
            Active: active,
        });
    };
    AdjTypeFactory.prototype.insertCompanyAdjType = function (companyAdjType) {
        return this.$http.post(WsUrl + "/InsertCompanyAdjType", {
            cat: companyAdjType,
        });
    };
    AdjTypeFactory.prototype.updateCompanyAdjType = function (companyAdjType) {
        return this.$http.post(WsUrl + "/UpdateCompanyAdjType", {
            cat: companyAdjType,
        });
    };
    AdjTypeFactory.prototype.getAllPayTypes = function () {
        return this.$http.post(WsUrl + "/GetPayTypes", {});
    };
    AdjTypeFactory.prototype.insertAdjTypeAndCompanyAdjType = function (companyAdjType) {
        return this.$http.post(WsUrl + "/InsertAdjTypeAndCompanyAdjType", {
            cat: companyAdjType,
        });
    };
    AdjTypeFactory.$inject = ["$http"];
    return AdjTypeFactory;
}());
var EmpAllocFactory = (function () {
    function EmpAllocFactory($http, csApiUrl) {
        this.$http = $http;
        this.csApiUrl = csApiUrl;
    }
    EmpAllocFactory.prototype.getByEmpID = function (empID) {
        return this.$http.get(this.csApiUrl + "/allocations/employee/" + empID);
    };
    EmpAllocFactory.$inject = ["$http", "csApiUrl"];
    return EmpAllocFactory;
}());
var EmpCommFactory = (function () {
    function EmpCommFactory($http, csApiUrl) {
        this.$http = $http;
        this.csApiUrl = csApiUrl;
    }
    EmpCommFactory.prototype.getByEmpID = function (empID) {
        return this.$http.get(this.csApiUrl + "/schedules/employee/" + empID);
    };
    EmpCommFactory.$inject = ["$http", "csApiUrl"];
    return EmpCommFactory;
}());
var EmpOverrideFactory = (function () {
    function EmpOverrideFactory($http, csApiUrl) {
        this.$http = $http;
        this.csApiUrl = csApiUrl;
    }
    EmpOverrideFactory.prototype.getByEmpID = function (empID) {
        return this.$http.get(this.csApiUrl + "/overrides/employee/" + empID);
    };
    EmpOverrideFactory.prototype.getOverridePaidTo = function (empID) {
        return this.$http.get(this.csApiUrl + "/emp-incentive-plan/paid-to/" + empID);
    };
    EmpOverrideFactory.prototype.getDisbursementsToEmployee = function (empID) {
        return this.$http.get(this.csApiUrl + "/disbursements/disbursements-to-employee/" + empID, {});
    };
    EmpOverrideFactory.$inject = ["$http", "csApiUrl"];
    return EmpOverrideFactory;
}());
var BranchPayrollMenuFactory = (function () {
    function BranchPayrollMenuFactory($http) {
        this.$http = $http;
    }
    BranchPayrollMenuFactory.prototype.get = function (id) {
        return this.$http.post(WsUrl + "/GetPayrollMenu", {});
    };
    BranchPayrollMenuFactory.$inject = ["$http"];
    return BranchPayrollMenuFactory;
}());
var UserMsgFactory = (function () {
    function UserMsgFactory($http) {
        this.$http = $http;
    }
    UserMsgFactory.prototype.SetMessage = function (msg) {
        return this.$http.post(WsUrl + "/SetUserMsg", {
            Message: msg,
        });
    };
    UserMsgFactory.$inject = ["$http"];
    return UserMsgFactory;
}());
var CompanyPayTimingFactory = (function () {
    function CompanyPayTimingFactory($http, csApiUrl) {
        this.$http = $http;
        this.csApiUrl = csApiUrl;
    }
    CompanyPayTimingFactory.prototype.get = function () {
        return this.$http.get(this.csApiUrl + "/companypaytiming");
    };
    CompanyPayTimingFactory.prototype.getGoalTimings = function () {
        return this.$http.get(this.csApiUrl + "/companypaytiming/goal");
    };
    CompanyPayTimingFactory.prototype.SaveCompanyPayTimings = function (payTimingList) {
        return this.$http.put(this.csApiUrl + "/companypaytiming", JSON.stringify(payTimingList));
    };
    CompanyPayTimingFactory.$inject = ["$http", "csApiUrl"];
    return CompanyPayTimingFactory;
}());
var CorporatePayrollMenuFactory = (function () {
    function CorporatePayrollMenuFactory($http, csApiUrl) {
        this.$http = $http;
        this.csApiUrl = csApiUrl;
    }
    CorporatePayrollMenuFactory.prototype.get = function (id) {
        return this.$http.post(WsUrl + "/GetPayrollMenu", {});
    };
    CorporatePayrollMenuFactory.prototype.GetPayrollCoCode = function () {
        return this.$http.post(WsUrl + "/GetPayrollCoCode", {});
    };
    CorporatePayrollMenuFactory.prototype.GetBranchGLCodes = function () {
        return this.$http.post(WsUrl + "/GetBranchGLCode", {});
    };
    CorporatePayrollMenuFactory.prototype.GetPayrollExportCount = function (payrollID, filters) {
        return this.$http.post(WsUrl + "/GetPayrollExportCount", {
            PayrollID: payrollID,
            Filters: filters
        });
    };
    CorporatePayrollMenuFactory.prototype.GetCompanyPayrollSystemID = function () {
        return this.$http.post(WsUrl + "/GetCompanyPayrollSystemID", {});
    };
    CorporatePayrollMenuFactory.prototype.GetPayrollSystems = function () {
        return this.$http.post(WsUrl + "/GetPayrollSystems", {});
    };
    CorporatePayrollMenuFactory.prototype.GetCompanyPayrollExports = function () {
        return this.$http.post(WsUrl + "/GetCompanyPayrollExports", {});
    };
    CorporatePayrollMenuFactory.prototype.GetPayrollSystemByID = function (payrollSystemID) {
        return this.$http.post(WsUrl + "/GetPayrollSystemByID", {
            PayrollSystemID: payrollSystemID
        });
    };
    CorporatePayrollMenuFactory.prototype.SaveCompanyPayrollExports = function (exportList) {
        return this.$http.post(WsUrl + "/UpdateCompanyPayrollExports", {
            exportList: exportList
        });
    };
    CorporatePayrollMenuFactory.prototype.GetGlJournalExportCount = function (payrollID, journal, coCode, startDt, stopDt) {
        return this.$http.post(WsUrl + "/GetGLJournalCount", {
            PayrollID: payrollID,
            Journal: journal,
            CoCode: coCode,
            StartDt: startDt,
            StopDt: stopDt,
        });
    };
    CorporatePayrollMenuFactory.prototype.GetCompanyGLSystemID = function () {
        return this.$http.post(WsUrl + "/GetCompanyGLSystemID", {});
    };
    CorporatePayrollMenuFactory.prototype.GetGLSystems = function () {
        return this.$http.post(WsUrl + "/GetGLSystems", {});
    };
    CorporatePayrollMenuFactory.prototype.RecalcLoanCompMulti = function (selectedPPs) {
        return this.$http.post(this.csApiUrl + "/compensation-processing/recalc-loan-comp-multi", selectedPPs);
    };
    CorporatePayrollMenuFactory.prototype.SingleEmployeeRecalc = function (selectedPPs, empID) {
        return this.$http.post(WsUrl + "/SingleEmployeeRecalc", {
            PayrollIDs: selectedPPs,
            EmployeeID: empID,
        });
    };
    CorporatePayrollMenuFactory.$inject = ["$http", "csApiUrl"];
    return CorporatePayrollMenuFactory;
}());
var DrawFactory = (function () {
    function DrawFactory($http, csApiUrl) {
        this.$http = $http;
        this.csApiUrl = csApiUrl;
    }
    DrawFactory.prototype.ProcessUnpaidDraws = function (pp) {
        return this.$http.post(WsUrl + "/ProcessUnpaidDraws", {
            PayrollID: pp,
        });
    };
    DrawFactory.prototype.getDrawBalance = function (empID) {
        return this.$http.get(this.csApiUrl + "/employees/" + empID + "/draw-balance");
    };
    DrawFactory.prototype.getEmpBalanceSummary = function (empID, startDt, stopDt, payCalendarID) {
        return this.$http.get(this.csApiUrl + "/compsnapshot/draws?EmpID=" + empID + "&StartDt="
            + startDt.toLocaleDateString('en-en') + "&StopDt=" + stopDt.toLocaleDateString('en-en') + "&PayCalendarID=" + payCalendarID);
    };
    DrawFactory.$inject = ["$http", "csApiUrl"];
    return DrawFactory;
}());
var AutoDrawFactory = (function () {
    function AutoDrawFactory($http, csApiUrl) {
        this.$http = $http;
        this.csApiUrl = csApiUrl;
    }
    AutoDrawFactory.prototype.getEmployee = function (brID, empID) {
        return this.$http.get(this.csApiUrl + "/employees/auto-draws?BranchID=" + brID + "&EmployeeID=" + empID);
    };
    AutoDrawFactory.prototype.delete = function (id) {
        return this.$http.delete(this.csApiUrl + "/auto-draw/" + id);
    };
    AutoDrawFactory.$inject = ["$http", "csApiUrl"];
    return AutoDrawFactory;
}());
var HeldPayTranFactory = (function () {
    function HeldPayTranFactory($http, csApiUrl) {
        this.$http = $http;
        this.csApiUrl = csApiUrl;
    }
    HeldPayTranFactory.prototype.getEmpHeldBalance = function (empID, startDt, stopDt, payCalendarID) {
        return this.$http.get(this.csApiUrl + "/compsnapshot/held?EmpID=" + empID + "&StartDt="
            + startDt.toLocaleDateString('en-en') + "&StopDt=" + stopDt.toLocaleDateString('en-en') + "&PayCalendarID=" + payCalendarID);
    };
    ;
    HeldPayTranFactory.$inject = ["$http", "csApiUrl"];
    return HeldPayTranFactory;
}());
var CommissionFactory = (function () {
    function CommissionFactory($http) {
        this.$http = $http;
    }
    CommissionFactory.prototype.UpdateCommissionLockDown = function (payCalendarID, payrollID, lockDownRequest, lockDownRequestTime, autoPTB) {
        return this.$http.post(WsUrl + "/UpdateCommissionLockDown", {
            PayCalendarID: payCalendarID,
            PayrollID: payrollID,
            LockDownRequest: lockDownRequest,
            LockDownRequestTime: lockDownRequestTime,
            AutoPTB: autoPTB
        });
    };
    CommissionFactory.prototype.UpdateCommissionUnlockDown = function (payrollID) {
        return this.$http.post(WsUrl + "/UpdateCommissionUnlockDown", {
            PayrollID: payrollID,
        });
    };
    CommissionFactory.prototype.CheckPendingManualDisbursementRequests = function (payrollId) {
        return this.$http.post(WsUrl + "/CheckPendingDisbursementRequests", {
            payrollId: payrollId,
        });
    };
    CommissionFactory.$inject = ["$http"];
    return CommissionFactory;
}());
var RegionFactory = (function () {
    function RegionFactory($http, csApiUrl) {
        this.$http = $http;
        this.csApiUrl = csApiUrl;
    }
    RegionFactory.prototype.get = function (id) {
        return this.$http.get(this.csApiUrl + ("/regions/details?regionId=" + id));
    };
    RegionFactory.prototype.save = function (Region) {
        if (Region.IsNew) {
            return this.$http.post(this.csApiUrl + "/regions/insert", __assign({}, Region));
        }
        else {
            return this.$http.post(this.csApiUrl + "/regions/update", __assign({}, Region));
        }
    };
    RegionFactory.prototype.getAllRegions = function () {
        return this.$http.get(this.csApiUrl + "/regions");
    };
    RegionFactory.prototype.getRegionByBrID = function (BranchID) {
        return this.$http.post(WsUrl + "/GetRegionByBrID", {
            BranchID: BranchID,
        });
    };
    RegionFactory.prototype.getRegions = function () {
        return this.$http.post(WsUrl + "/GetRegionInfo", {
            AccessLevelType: "Default",
        });
    };
    RegionFactory.prototype.getRegionDDLDataFill = function () {
        return this.$http.post(WsUrl + "/GetRegionDDLDataFill", {
            ProductionReg: 2,
        });
    };
    RegionFactory.$inject = ["$http", "csApiUrl"];
    return RegionFactory;
}());
var RvpFactory = (function () {
    function RvpFactory($http, csApiUrl) {
        this.$http = $http;
        this.csApiUrl = csApiUrl;
    }
    RvpFactory.prototype.get = function () {
        return this.$http.get(this.csApiUrl + "/employees/rvp");
    };
    RvpFactory.$inject = ["$http", "csApiUrl"];
    return RvpFactory;
}());
var AddressStatesFactory = (function () {
    function AddressStatesFactory() {
        this.states = [
            "AK",
            "AL",
            "AR",
            "AZ",
            "CA",
            "CO",
            "CT",
            "DC",
            "DE",
            "FL",
            "GA",
            "HI",
            "IA",
            "ID",
            "IL",
            "IN",
            "KS",
            "KY",
            "LA",
            "MA",
            "MD",
            "ME",
            "MI",
            "MN",
            "MO",
            "MS",
            "MT",
            "NC",
            "ND",
            "NE",
            "NH",
            "NJ",
            "NM",
            "NV",
            "NY",
            "OH",
            "OK",
            "OR",
            "PA",
            "RI",
            "SC",
            "SD",
            "TN",
            "TX",
            "UT",
            "VA",
            "VT",
            "WA",
            "WI",
            "WV",
            "WY",
        ];
    }
    return AddressStatesFactory;
}());
var DivisionManagerAccessFactory = (function () {
    function DivisionManagerAccessFactory($http, $q) {
        this.$http = $http;
        this.$q = $q;
    }
    DivisionManagerAccessFactory.prototype.onSuccess = function (response) {
        return response.data.d;
    };
    DivisionManagerAccessFactory.prototype.onFailure_GetAllRegions = function () {
        return this.$q.reject("Failed to get regions");
    };
    DivisionManagerAccessFactory.prototype.GetAllRegions = function () {
        return this.$http
            .post(WsUrl + "/GetRegionInfo", {
            AccessLevelType: "Default",
        })
            .then(this.onSuccess, this.onFailure_GetAllRegions);
    };
    DivisionManagerAccessFactory.prototype.onFailure_GetRegionsForEmployee = function () {
        return this.$q.reject("Failed to get employee region list");
    };
    DivisionManagerAccessFactory.prototype.GetRegionsForEmployee = function (employeeID) {
        return this.$http
            .post(WsUrl + "/GetRegionsForEmployee", {
            EmpID: employeeID,
        })
            .then(this.onSuccess, this.onFailure_GetRegionsForEmployee);
    };
    DivisionManagerAccessFactory.prototype.onFailure_GetAssignedRegionsForEmployee = function () {
        return this.$q.reject("Failed to get employee assigned branch list");
    };
    DivisionManagerAccessFactory.prototype.GetAssignedRegionsForEmployee = function (EmployeeID) {
        return this.$http
            .post(WsUrl + "/GetAssignedRegionsByEmpID", {
            EmployeeID: EmployeeID,
        })
            .then(this.onSuccess, this.onFailure_GetAssignedRegionsForEmployee);
    };
    DivisionManagerAccessFactory.prototype.onFailure_InsertRegionForEmployee = function () {
        return this.$q.reject("Failed to insert employee region");
    };
    DivisionManagerAccessFactory.prototype.InsertRegionForEmployee = function (EmployeeID, RegionID) {
        return this.$http
            .post(WsUrl + "/InsertEmployeeRegionAccess", {
            EmployeeID: EmployeeID,
            RegionID: RegionID,
        })
            .then(this.onSuccess, this.onFailure_InsertRegionForEmployee);
    };
    DivisionManagerAccessFactory.prototype.onFailure_DeleteRegionForEmployee = function () {
        return this.$q.reject("Failed to delete employee region");
    };
    DivisionManagerAccessFactory.prototype.DeleteRegionForEmployee = function (employeeID, regionID) {
        return this.$http
            .post(WsUrl + "/DeleteEmployeeRegionAccess", {
            EmployeeID: employeeID,
            RegionID: regionID,
        })
            .then(this.onSuccess, this.onFailure_DeleteRegionForEmployee);
    };
    DivisionManagerAccessFactory.$inject = ["$http", "$q"];
    return DivisionManagerAccessFactory;
}());
var AreaManagerAccessFactory = (function () {
    function AreaManagerAccessFactory($http, $q) {
        this.$http = $http;
        this.$q = $q;
    }
    AreaManagerAccessFactory.prototype.onSuccess = function (response) {
        return response.data.d;
    };
    AreaManagerAccessFactory.prototype.onFailure_GetAllRegions = function () {
        return this.$q.reject("Failed to get regions");
    };
    AreaManagerAccessFactory.prototype.GetAllRegions = function () {
        return this.$http
            .post(WsUrl + "/GetRegionInfo", {
            AccessLevelType: "Default",
        })
            .then(this.onSuccess, this.onFailure_GetAllRegions);
    };
    AreaManagerAccessFactory.prototype.onFailure_GetMasterBranchesForRegion = function () {
        return this.$q.reject("Failed to get branches");
    };
    AreaManagerAccessFactory.prototype.GetMasterBranchesForRegion = function (RegionID) {
        return this.$http
            .post(WsUrl + "/GetBranchInfo" + OldApiReadOnlySession, {
            RegionID: RegionID,
            BrInclSubs: true,
            Active: 1,
            AccessLevelType: "Default",
        })
            .then(this.onSuccess, this.onFailure_GetMasterBranchesForRegion);
    };
    AreaManagerAccessFactory.prototype.onFailure_GetManagerByID = function () {
        return this.$q.reject("Failed to get manager detail");
    };
    AreaManagerAccessFactory.prototype.GetManagerByID = function (EmployeeID) {
        return this.$http
            .post(WsUrl + "/GetEmployeeInfoByID", {
            RegionID: 0,
            BranchID: 0,
            EmpID: EmployeeID,
            AccessLevelType: "Default",
        })
            .then(this.onSuccess, this.onFailure_GetManagerByID);
    };
    AreaManagerAccessFactory.prototype.onFailure_GetBranchesForEmployee = function () {
        return this.$q.reject("Failed to get employee branch list");
    };
    AreaManagerAccessFactory.prototype.GetBranchesForEmployee = function (EmployeeID) {
        return this.$http
            .post(WsUrl + "/GetBranchesForEmployee", {
            EmpID: EmployeeID,
        })
            .then(this.onSuccess, this.onFailure_GetBranchesForEmployee);
    };
    AreaManagerAccessFactory.prototype.onFailure_GetAssignedBranchesForEmployee = function () {
        return this.$q.reject("Failed to get employee assigned branch list");
    };
    AreaManagerAccessFactory.prototype.GetAssignedBranchesForEmployee = function (EmployeeID) {
        return this.$http
            .post(WsUrl + "/GetAssignedBranchesByEmpID", {
            EmployeeID: EmployeeID,
        })
            .then(this.onSuccess, this.onFailure_GetAssignedBranchesForEmployee);
    };
    AreaManagerAccessFactory.prototype.onFailure_InsertBranchForEmployee = function () {
        return this.$q.reject("Failed to insert employee branch");
    };
    AreaManagerAccessFactory.prototype.InsertBranchForEmployee = function (EmployeeID, BranchID) {
        return this.$http
            .post(WsUrl + "/InsertEmployeeBranchAccess", {
            EmployeeID: EmployeeID,
            BranchID: BranchID,
        })
            .then(this.onSuccess, this.onFailure_InsertBranchForEmployee);
    };
    AreaManagerAccessFactory.prototype.onFailure_DeleteBranchForEmployee = function () {
        return this.$q.reject("Failed to delete employee branch");
    };
    AreaManagerAccessFactory.prototype.DeleteBranchForEmployee = function (EmployeeID, BranchID) {
        return this.$http
            .post(WsUrl + "/DeleteEmployeeBranchAccess", {
            EmployeeID: EmployeeID,
            BranchID: BranchID,
        })
            .then(this.onSuccess, this.onFailure_DeleteBranchForEmployee);
    };
    AreaManagerAccessFactory.$inject = ["$http", "$q"];
    return AreaManagerAccessFactory;
}());
var CompensationFactory = (function () {
    function CompensationFactory($http, csApiUrl) {
        this.$http = $http;
        this.csApiUrl = csApiUrl;
    }
    CompensationFactory.prototype.ConfirmEmpOverride = function (EmpOverrideID) {
        return this.$http.post(WsUrl + "/UpdateEmpOverrideConfirmation", {
            EmpOverrideID: EmpOverrideID,
        });
    };
    CompensationFactory.prototype.DeleteEmpOverride = function (EmpOverrideID) {
        return this.$http.delete(this.csApiUrl + "/emp-incentive-plan/" + EmpOverrideID);
    };
    CompensationFactory.prototype.GetLoanCompensation = function (LoanID) {
        return this.$http.post(WsUrl + "/GetLoanCompensation", {
            LoanID: LoanID,
        });
    };
    CompensationFactory.prototype.HasLateTrans = function (LoanID) {
        return this.$http.post(WsUrl + "/HasLateTrans", {
            LoanID: LoanID,
        });
    };
    CompensationFactory.prototype.OnboardingClearComp = function (clearCompParams) {
        return this.$http.post(this.csApiUrl + "/onboarding-clear-comp", clearCompParams);
    };
    CompensationFactory.prototype.RecalcIncentivePlans = function () {
        return this.$http.post(this.csApiUrl + "/compensation-processing/recalc-incentive-plans", {});
    };
    CompensationFactory.$inject = ["$http", "csApiUrl"];
    return CompensationFactory;
}());
var PositionFactory = (function () {
    function PositionFactory($http) {
        this.$http = $http;
    }
    PositionFactory.prototype.getPositions = function () {
        return this.$http.post(WsUrl + "/GetAllPositions", {});
    };
    PositionFactory.prototype.getCompanyPositions = function () {
        return this.$http.post(WsUrl + "/GetCompanyPositions", {});
    };
    PositionFactory.prototype.insertCompanyPosition = function (companyPosition) {
        return this.$http.post(WsUrl + "/InsertCompanyPosition", {
            companyPosition: companyPosition,
        });
    };
    PositionFactory.prototype.updateCompanyPosition = function (companyPosition) {
        return this.$http.post(WsUrl + "/UpdateCompanyPosition", {
            companyPosition: companyPosition,
        });
    };
    PositionFactory.$inject = ["$http"];
    return PositionFactory;
}());
var TermRuleFactory = (function () {
    function TermRuleFactory($http) {
        this.$http = $http;
    }
    TermRuleFactory.prototype.getTermRules = function () {
        return this.$http.post(WsUrl + "/GetTermRules", {});
    };
    TermRuleFactory.prototype.getCompanyTermRules = function () {
        return this.$http.post(WsUrl + "/GetCompanyTermRules", {});
    };
    TermRuleFactory.prototype.getCompanyTermRulesByCompanyShortName = function (csn) {
        return this.$http.post(WsUrl + "/GetCompanyTermRulesByCompanyShortName", {
            CompanyShortName: csn,
        });
    };
    TermRuleFactory.prototype.updateCompanyTermRuleForAdmin = function (csn, ctrid, tid, active) {
        return this.$http.post(WsUrl + "/UpdateCompanyTermRuleForAdmin", {
            CompanyShortName: csn,
            CompanyTermRuleID: ctrid,
            TermRuleID: tid,
            Active: active,
        });
    };
    TermRuleFactory.prototype.InsertCompanyTermRuleForAdmin = function (csn, tid) {
        return this.$http.post(WsUrl + "/InsertCompanyTermRuleForAdmin", {
            CompanyShortName: csn,
            TermRuleID: tid,
        });
    };
    TermRuleFactory.prototype.updateCompanyAssignGroupTermRule = function (assignGroup, companyTermRuleID) {
        return this.$http.post(WsUrl + "/UpdateCompanyAssignGroupTermRule", {
            AssignGroup: assignGroup,
            CompanyTermRuleID: companyTermRuleID,
        });
    };
    TermRuleFactory.$inject = ["$http"];
    return TermRuleFactory;
}());
var EmployeeLogFactory = (function () {
    function EmployeeLogFactory($http, csApiUrl) {
        this.$http = $http;
        this.csApiUrl = csApiUrl;
    }
    EmployeeLogFactory.prototype.GetEmployeeLog = function (empID) {
        return this.$http.get(this.csApiUrl + "/employees/" + empID + "/logs");
    };
    EmployeeLogFactory.$inject = ["$http", "csApiUrl"];
    return EmployeeLogFactory;
}());
var EmployeeRelationshipFactory = (function () {
    function EmployeeRelationshipFactory($http, csApiUrl) {
        this.$http = $http;
        this.csApiUrl = csApiUrl;
    }
    EmployeeRelationshipFactory.prototype.getRelationshipsByEmpID = function (empID) {
        return this.$http.get(this.csApiUrl + "/employee-relationships/" + empID);
    };
    EmployeeRelationshipFactory.prototype.getInverseRelationshipsByEmpID = function (empID) {
        return this.$http.get(this.csApiUrl + "/employee-relationships/inverse/" + empID);
    };
    EmployeeRelationshipFactory.prototype.getRelationshipTypes = function () {
        return this.$http.get(this.csApiUrl + "/employee-relationships/types");
    };
    EmployeeRelationshipFactory.prototype.deleteRelationship = function (relationshipID) {
        return this.$http.delete(this.csApiUrl + "/employee-relationships/" + relationshipID);
    };
    EmployeeRelationshipFactory.$inject = ["$http", "csApiUrl"];
    return EmployeeRelationshipFactory;
}());
var DocsFactory = (function () {
    function DocsFactory($http, csApiUrl) {
        this.$http = $http;
        this.csApiUrl = csApiUrl;
    }
    DocsFactory.prototype.get = function (empID) {
        return this.$http.get(this.csApiUrl + "/employees/" + empID + "/documents");
    };
    DocsFactory.prototype.save = function (doc) {
        return this.$http.post(WsUrl + "/SaveEmpDocument", {
            Document: doc,
        });
    };
    DocsFactory.prototype.getTypes = function () {
        return this.$http.get(this.csApiUrl + "/document/types");
    };
    DocsFactory.prototype.confirm = function (empDocID) {
        return this.$http.post(WsUrl + "/SaveDocumentReceipt", {
            EmpDocID: empDocID,
        });
    };
    DocsFactory.prototype.inactivate = function (empDoc) {
        return this.$http.post(WsUrl + "/InactivateEmpDoc", {
            EmpDocID: empDoc.empDocID,
            StopDt: empDoc.stopDt,
        });
    };
    DocsFactory.prototype.delete = function (empDocID) {
        return this.$http.post(WsUrl + "/DeleteEmpDoc", {
            EmpDocID: empDocID,
        });
    };
    DocsFactory.$inject = ["$http", "csApiUrl"];
    return DocsFactory;
}());
var ExportDataFactory = (function () {
    function ExportDataFactory($http, $q, $window) {
        this.$http = $http;
        this.$q = $q;
        this.$window = $window;
        this.SelfUrl = ResolveUrl("~/ng/admin-menu");
    }
    ExportDataFactory.prototype.export = function (type, param) {
        var _this = this;
        switch (type) {
            case "branch_employees":
                this.getCountUrl = WsUrl + "/GetBranchEmployeesExportCountUrl";
                this.urlParams = "action=ExportBranchEmployees";
                break;
            case "branches":
                this.getCountUrl = WsUrl + "/GetBranchesExportCount";
                this.urlParams = "action=ExportBranches";
                break;
            case "schedules":
                this.getCountUrl = WsUrl + "/GetCompensationScheduleCount";
                this.urlParams = "action=ExportSchedules";
                this.displayType = "Schedule";
                break;
            case "allocations":
                this.getCountUrl = WsUrl + "/GetEmpAllocCount";
                this.urlParams = "action=ExportAllocations";
                this.displayType = "Allocation";
                break;
            case "incentivePlans":
                this.getCountUrl = WsUrl + "/GetEmpOverrideCount";
                this.urlParams = "action=ExportIncentivePlans";
                this.displayType = "Incentive Plan";
                break;
        }
        return this.getExportCount().then(function (resp) { return _this.hitExportUrl(resp); }, function (resp) { return _this.onFailure_getExportCount(resp); });
    };
    ExportDataFactory.prototype.getExportCount = function () {
        if (this.getCountUrl == null) {
            return this.$q.reject("A " + this.displayType + " records count is not available.");
        }
        else {
            return this.$http.post(this.getCountUrl, {});
        }
    };
    ExportDataFactory.prototype.hitExportUrl = function (response) {
        var count = response.data.d;
        if (count == null || count === 0) {
            return this.$q.reject("No " + this.displayType + " records could be found.");
        }
        else if (count === -1) {
            return this.$q.reject("You do not have permission to export " + this.displayType + " records.");
        }
        else if (this.urlParams == null) {
            return this.$q.reject("Export functionality is not available for " + this.displayType + ".");
        }
        else {
            this.$window.open(this.SelfUrl + "?" + this.urlParams, "_self");
        }
    };
    ExportDataFactory.prototype.onFailure_getExportCount = function (response) {
        return this.$q.reject("The " + this.displayType + " records count failed.");
    };
    ExportDataFactory.$inject = ["$http", "$q", "$window"];
    return ExportDataFactory;
}());
var SessionFactory = (function () {
    function SessionFactory($http, $q) {
        this.$http = $http;
        this.$q = $q;
    }
    SessionFactory.prototype.getSessionVariables = function () {
        return this.$http.post(WsUrl + "/GetSessionVariables" + OldApiReadOnlySession, {});
    };
    SessionFactory.prototype.setEmployeeID = function (eid) {
        return this.$http.post(WsUrl + "/SetEmployeeID", {
            EmpID: eid,
        });
    };
    SessionFactory.prototype.setPayrollStartDate = function (dt) {
        return this.$http.post(WsUrl + "/SetPayrollStartDate", {
            StartDt: dt,
        });
    };
    SessionFactory.prototype.setPayrollStopDate = function (dt) {
        return this.$http.post(WsUrl + "/SetPayrollStopDate", {
            StopDt: dt,
        });
    };
    SessionFactory.prototype.setPayCalendarID = function (id) {
        return this.$http.post(WsUrl + "/SetPayCalendarID", {
            PayCalendarID: id,
        });
    };
    SessionFactory.prototype.setPayPeriodOffset = function (offset, mode) {
        return this.$http.post(WsUrl + "/SetPayPeriodOffset", {
            PayPeriodOffset: offset,
            PayPeriodOffsetMode: mode,
        });
    };
    SessionFactory.prototype.onSuccess_set = function () {
        return this.$q.resolve();
    };
    SessionFactory.prototype.onFailure_set = function () {
        return this.$q.reject("Failed to set the " + this.type + " session correctly.");
    };
    SessionFactory.$inject = ["$http", "$q"];
    return SessionFactory;
}());
var ProductionFactory = (function () {
    function ProductionFactory($http) {
        this.$http = $http;
    }
    ProductionFactory.prototype.getBranchProductionByPurpose = function (regID, brID, empID, startDt, stopDt, channel, projMethod, period) {
        return this.$http.post(WsUrl + "/GetBranchProductionByPurpose", {
            RegID: regID,
            BrID: brID,
            EmpID: empID,
            FromDate: startDt,
            ToDate: stopDt,
            Channel: channel,
            ProjectionMethod: projMethod,
            Period: period,
        });
    };
    ProductionFactory.prototype.getBranchProductionByLoanType = function (regID, brID, empID, startDt, stopDt, channel) {
        return this.$http.post(WsUrl + "/GetBranchProductionByLoanType", {
            RegID: regID,
            BrID: brID,
            EmpID: empID,
            FromDate: startDt,
            ToDate: stopDt,
            Channel: channel,
        });
    };
    ProductionFactory.prototype.getProjectionsByBranch = function (regID, brID, empID, startDt, stopDt, channel) {
        return this.$http.post(WsUrl + "/GetProjectionsByBranch", {
            RegID: regID,
            BrID: brID,
            EmpID: empID,
            FromDate: startDt,
            ToDate: stopDt,
            Channel: channel,
        });
    };
    ProductionFactory.$inject = ["$http"];
    return ProductionFactory;
}());
var PipelineFactory = (function () {
    function PipelineFactory($http) {
        this.$http = $http;
    }
    PipelineFactory.prototype.getBranchPipelineByLoanStatus = function (regID, brID, empID, channel, month, lockstatuscode) {
        return this.$http.post(WsUrl + "/GetBranchPipelineByLoanStatus", {
            RegID: regID,
            BrID: brID,
            EmpID: empID,
            Channel: channel,
            Month: month,
            LockStatusCode: lockstatuscode,
        });
    };
    PipelineFactory.prototype.getPipelineByLoanType = function (regID, brID, empID, channel, month, lockstatuscode) {
        return this.$http.post(WsUrl + "/GetPipelineByLoanType", {
            RegID: regID,
            BrID: brID,
            EmpID: empID,
            Channel: channel,
            Month: month,
            LockStatusCode: lockstatuscode,
        });
    };
    PipelineFactory.prototype.getPipelineByPurpose = function (regID, brID, empID, channel, month, lockstatuscode) {
        return this.$http.post(WsUrl + "/GetPipelineByPurpose", {
            RegID: regID,
            BrID: brID,
            EmpID: empID,
            Channel: channel,
            Month: month,
            LockStatusCode: lockstatuscode,
        });
    };
    PipelineFactory.prototype.getDailyPipelineLocked = function (regID, brID, empID, channel, month) {
        return this.$http.post(WsUrl + "/GetDailyPipelineLocked", {
            RegID: regID,
            BrID: brID,
            EmpID: empID,
            Channel: channel,
            Month: month,
        });
    };
    PipelineFactory.prototype.getDailyPipelineExpired = function (regID, brID, empID, channel, month) {
        return this.$http.post(WsUrl + "/GetDailyPipelineExpired", {
            RegID: regID,
            BrID: brID,
            EmpID: empID,
            Channel: channel,
            Month: month,
        });
    };
    PipelineFactory.$inject = ["$http"];
    return PipelineFactory;
}());
var SocialMediaFactory = (function () {
    function SocialMediaFactory($http) {
        this.$http = $http;
    }
    SocialMediaFactory.prototype.getEmployeeSocialMedia = function (empID) {
        return this.$http.post(WsUrl + "/GetEmpSocialMedia", {
            EmpID: empID,
        });
    };
    SocialMediaFactory.prototype.saveEmployeeSocialMedia = function (socialMediaList, empID) {
        return this.$http.post(WsUrl + "/UpdateEmpSocialMedia", {
            EmpSocialMedia: socialMediaList,
            EmpID: empID,
        });
    };
    SocialMediaFactory.$inject = ["$http"];
    return SocialMediaFactory;
}());
var EmployeeNotesFactory = (function () {
    function EmployeeNotesFactory($http) {
        this.$http = $http;
    }
    EmployeeNotesFactory.prototype.get = function (empID) {
        return this.$http.post(WsUrl + "/GetEmployeeNotes", {
            EmployeeID: empID,
        });
    };
    EmployeeNotesFactory.prototype.insert = function (notes, empID) {
        return this.$http.post(WsUrl + "/InsertEmployeeNotes", {
            Notes: notes,
            EmployeeID: empID,
        });
    };
    EmployeeNotesFactory.prototype.update = function (notes, empID) {
        return this.$http.post(WsUrl + "/UpdateEmployeeNotes", {
            Notes: notes,
            EmployeeID: empID,
        });
    };
    EmployeeNotesFactory.prototype.delete = function (empID) {
        return this.$http.post(WsUrl + "/DeleteEmployeeNotes", {
            EmployeeID: empID,
        });
    };
    EmployeeNotesFactory.$inject = ["$http"];
    return EmployeeNotesFactory;
}());
var LOSystemFactory = (function () {
    function LOSystemFactory($http) {
        this.$http = $http;
    }
    LOSystemFactory.prototype.GetAll = function () {
        return this.$http.post(WsUrl + "/GetLOSystems", {});
    };
    LOSystemFactory.$inject = ["$http"];
    return LOSystemFactory;
}());
var CompanyAccessSectionFactory = (function () {
    function CompanyAccessSectionFactory($http) {
        this.$http = $http;
    }
    CompanyAccessSectionFactory.prototype.getCompanyAccessSection = function () {
        return this.$http.post(WsUrl + "/GetCompanyAccessSection", {});
    };
    CompanyAccessSectionFactory.prototype.insertCompanyAccessSection = function (section) {
        return this.$http.post(WsUrl + "/InsertCompanyAccessSection", {
            Section: section,
        });
    };
    CompanyAccessSectionFactory.prototype.deleteCompanyAccessSection = function (id) {
        return this.$http.post(WsUrl + "/DeleteCompanyAccessSection", {
            Id: id,
        });
    };
    CompanyAccessSectionFactory.$inject = ["$http"];
    return CompanyAccessSectionFactory;
}());
var AccessSectionFactory = (function () {
    function AccessSectionFactory($http) {
        this.$http = $http;
    }
    AccessSectionFactory.prototype.getAccessSection = function () {
        return this.$http.post(WsUrl + "/GetAccessSection", {});
    };
    AccessSectionFactory.$inject = ["$http"];
    return AccessSectionFactory;
}());
var PurposeIndicatorFactory = (function () {
    function PurposeIndicatorFactory($http) {
        this.$http = $http;
    }
    PurposeIndicatorFactory.prototype.get = function () {
        return this.$http.post(WsUrl + "/GetPurposeIndicators", {});
    };
    PurposeIndicatorFactory.$inject = ["$http"];
    return PurposeIndicatorFactory;
}());
var LoanContactFactory = (function () {
    function LoanContactFactory($http) {
        this.$http = $http;
    }
    LoanContactFactory.prototype.get = function (loanID) {
        return this.$http.post(WsUrl + "/GetLoanContacts", {
            LoanID: loanID,
        });
    };
    LoanContactFactory.prototype.getInvestorInfo = function (loanID) {
        return this.$http.post(WsUrl + "/GetInvestorInfo", {
            LoanID: loanID,
        });
    };
    LoanContactFactory.prototype.getServicerInfo = function (loanID) {
        return this.$http.post(WsUrl + "/GetServicerInfo", {
            LoanID: loanID,
        });
    };
    LoanContactFactory.$inject = ["$http"];
    return LoanContactFactory;
}());
var LoanFeeFactory = (function () {
    function LoanFeeFactory($http) {
        this.$http = $http;
    }
    LoanFeeFactory.prototype.get = function (loanID) {
        return this.$http.post(WsUrl + "/GetLoanFeeDetails", {
            LoanID: loanID,
        });
    };
    LoanFeeFactory.prototype.getTargets = function (loanID) {
        return this.$http.post(WsUrl + "/GetLoanTargetDetails", {
            LoanID: loanID,
        });
    };
    LoanFeeFactory.$inject = ["$http"];
    return LoanFeeFactory;
}());
var LoanDocumentFactory = (function () {
    function LoanDocumentFactory($http) {
        this.$http = $http;
    }
    LoanDocumentFactory.prototype.get = function (loanID) {
        return this.$http.post(WsUrl + "/GetLoanDocuments", {
            LoanID: loanID,
        });
    };
    LoanDocumentFactory.$inject = ["$http"];
    return LoanDocumentFactory;
}());
var LoanFactory = (function () {
    function LoanFactory($http) {
        this.$http = $http;
    }
    LoanFactory.prototype.get = function (loanID) {
        return this.$http.post(WsUrl + "/GetLoanByLoanID", {
            LoanID: loanID,
        });
    };
    LoanFactory.prototype.getByLoanNo = function (loanNo) {
        return this.$http.post(WsUrl + "/GetLoanByLoanNo", {
            LoanNo: loanNo,
        });
    };
    LoanFactory.prototype.getLoanKeys = function () {
        return this.$http.post(WsUrl + "/GetLoanKeys", {});
    };
    LoanFactory.prototype.getLoanAccess = function () {
        return this.$http.post(WsUrl + "/GetLoanAccess", {});
    };
    LoanFactory.prototype.getAllLoanDatesByGroup = function (loanID, loanNo) {
        return this.$http.post(WsUrl + "/GetAllLoanDatesByGroup", {
            LoanID: loanID,
            LoanNo: loanNo,
        });
    };
    LoanFactory.$inject = ["$http"];
    return LoanFactory;
}());
var StateFactory = (function () {
    function StateFactory($http) {
        this.$http = $http;
    }
    StateFactory.prototype.get = function () {
        return this.$http.post(WsUrl + "/GetStates", {
            ID: 0,
        });
    };
    StateFactory.$inject = ["$http"];
    return StateFactory;
}());
var PardotExportFactory = (function () {
    function PardotExportFactory($http) {
        this.$http = $http;
    }
    PardotExportFactory.prototype.export = function (accessLevels, companyIDs) {
        return this.$http.post(WsUrl + "/SetExportPardotArrays", {
            AccessLevels: accessLevels,
            CompanyIDs: companyIDs,
        });
    };
    PardotExportFactory.$inject = ["$http"];
    return PardotExportFactory;
}());
var MetricFactory = (function () {
    function MetricFactory($http, csApiUrl) {
        this.$http = $http;
        this.csApiUrl = csApiUrl;
    }
    MetricFactory.prototype.getCompanyMetrics = function (companyMetricID) {
        return this.$http.post(WsUrl + "/GetCompanyMetrics", {
            CompanyMetricID: companyMetricID,
        });
    };
    MetricFactory.prototype.getMetricGridDetail = function (metricScoreGridMasterID) {
        return this.$http.post(WsUrl + "/GetMetricGridDetail", {
            MetricScoreGridMasterID: metricScoreGridMasterID,
        });
    };
    MetricFactory.prototype.getCompanyMetricTagValues = function (companyMetricID) {
        return this.$http.post(WsUrl + "/GetCompanyMetricTagValues", {
            CompanyMetricID: companyMetricID,
        });
    };
    MetricFactory.prototype.getCompanyMetricTagValuesDDL = function (metricScoreGridMasterID) {
        return this.$http.post(WsUrl + "/GetCompanyMetricTagValuesDDL", {
            MetricScoreGridMasterID: metricScoreGridMasterID,
        });
    };
    MetricFactory.prototype.getAllCompanyMetricTagValues = function (companyMetricID) {
        return this.$http.post(WsUrl + "/GetAllCompanyMetricTagValues", {
            CompanyMetricID: companyMetricID,
        });
    };
    MetricFactory.prototype.getMetricOperations = function () {
        return this.$http.post(WsUrl + "/GetMetricOperations", {});
    };
    MetricFactory.prototype.getLoanMetrics = function (LoanID) {
        return this.$http.post(WsUrl + "/GetLoanMetrics", {
            LoanID: LoanID,
        });
    };
    MetricFactory.prototype.getEmpMetrics = function (empID, metricStatus) {
        var status = (metricStatus === undefined ? "" : metricStatus);
        return this.$http.get(this.csApiUrl + "/employeelevelmetric?EmpID=" + empID
            + "&MetricStatus=" + status);
    };
    MetricFactory.prototype.getMetricsForCompany = function () {
        return this.$http.get(this.csApiUrl + "/employeelevelmetric/companymetrics");
    };
    MetricFactory.prototype.upsertEmpMetrics = function (empId, empLevelMetric) {
        return this.$http.put(this.csApiUrl + "/employeelevelmetric/" + empId, JSON.stringify(empLevelMetric));
    };
    MetricFactory.prototype.deleteEmpMetric = function (empLevelMetricId) {
        return this.$http.delete(this.csApiUrl + "/employeelevelmetric/" + empLevelMetricId);
    };
    MetricFactory.prototype.checkAllowDelete = function (companyMetricID) {
        return this.$http.post(WsUrl + "/CheckAllowDeleteCompanyMetric", {
            CompanyMetricID: companyMetricID,
        });
    };
    MetricFactory.prototype.checkAllowDeleteMaster = function (metricScoreGridMasterID) {
        return this.$http.post(WsUrl + "/CheckAllowDeleteMetricScoreGridMaster", {
            MetricScoreGridMasterID: metricScoreGridMasterID,
        });
    };
    MetricFactory.prototype.delete = function (companyMetricID) {
        return this.$http.post(WsUrl + "/DeleteCompanyMetric", {
            CompanyMetricID: companyMetricID,
        });
    };
    MetricFactory.prototype.deleteGrid = function (metricScoreGridMasterID) {
        return this.$http.post(WsUrl + "/DeleteMetricGrid", {
            MetricScoreGridMasterID: metricScoreGridMasterID,
        });
    };
    MetricFactory.prototype.save = function (metric) {
        return this.$http.post(WsUrl + "/SaveMetric", {
            Metric: metric,
        });
    };
    MetricFactory.prototype.saveMetricGrid = function (metricGrid) {
        return this.$http.post(WsUrl + "/SaveMetricGrid", {
            MetricGrid: metricGrid,
        });
    };
    MetricFactory.$inject = ["$http", "csApiUrl"];
    return MetricFactory;
}());
var FLSAStatusFactory = (function () {
    function FLSAStatusFactory($http) {
        this.$http = $http;
    }
    FLSAStatusFactory.prototype.get = function () {
        return this.$http.post(WsUrl + "/GetCompanyFLSAStatus", {});
    };
    FLSAStatusFactory.$inject = ["$http"];
    return FLSAStatusFactory;
}());
var WageCategoryFactory = (function () {
    function WageCategoryFactory($http) {
        this.$http = $http;
    }
    WageCategoryFactory.prototype.get = function () {
        return this.$http.post(WsUrl + "/GetCompanyWageCategory", {});
    };
    WageCategoryFactory.$inject = ["$http"];
    return WageCategoryFactory;
}());
var FileUploadQueueFactory = (function () {
    function FileUploadQueueFactory($http) {
        this.$http = $http;
    }
    FileUploadQueueFactory.prototype.getAll = function (CompanyID) {
        return this.$http.post(WsUrl + "/GetAllFileUploadQueue", {
            CompanyID: CompanyID,
        });
    };
    FileUploadQueueFactory.$inject = ["$http"];
    return FileUploadQueueFactory;
}());
var LoanTableMappingFactory = (function () {
    function LoanTableMappingFactory($http) {
        this.$http = $http;
    }
    LoanTableMappingFactory.prototype.getAll = function (CompanyID) {
        return this.$http.post(WsUrl + "/GetAllLoanTableMapping", {
            CompanyID: CompanyID,
        });
    };
    LoanTableMappingFactory.$inject = ["$http"];
    return LoanTableMappingFactory;
}());
var FastFetchFactory = (function () {
    function FastFetchFactory($http, csApiUrl) {
        this.$http = $http;
        this.csApiUrl = csApiUrl;
    }
    FastFetchFactory.prototype.submitRequest = function (LoanList) {
        return this.$http.post(this.csApiUrl + "/fastfetch/submitrequest", JSON.stringify(LoanList));
    };
    FastFetchFactory.$inject = ["$http", "csApiUrl"];
    return FastFetchFactory;
}());
var HeadcountRoleFactory = (function () {
    function HeadcountRoleFactory($http) {
        this.$http = $http;
    }
    HeadcountRoleFactory.prototype.getAll = function () {
        return this.$http.post(WsUrl + "/GetHeadcountRoles", {});
    };
    HeadcountRoleFactory.prototype.insertCompanyHeadcountRoleCategory = function (CompanyHeadcountRoleCategory) {
        return this.$http.post(WsUrl + "/InsertCompanyHeadcountRole", {
            CompanyHeadcountRoleCategory: CompanyHeadcountRoleCategory,
        });
    };
    HeadcountRoleFactory.$inject = ["$http"];
    return HeadcountRoleFactory;
}());
var RoleCategoryFactory = (function () {
    function RoleCategoryFactory($http) {
        this.$http = $http;
    }
    RoleCategoryFactory.prototype.getAll = function () {
        return this.$http.post(WsUrl + "/GetRoleCategories", {});
    };
    RoleCategoryFactory.$inject = ["$http"];
    return RoleCategoryFactory;
}());
var MarketingFactory = (function () {
    function MarketingFactory($http, csApiUrl) {
        this.$http = $http;
        this.csApiUrl = csApiUrl;
    }
    MarketingFactory.prototype.getEmpMarketingBalance = function (empID, startDt, stopDt, payCalendarID) {
        return this.$http.get(this.csApiUrl + "/compsnapshot/marketing?EmpID=" + empID + "&StartDt="
            + startDt.toLocaleDateString('en-en') + "&StopDt=" + stopDt.toLocaleDateString('en-en') + "&PayCalendarID=" + payCalendarID);
    };
    MarketingFactory.$inject = ["$http", "csApiUrl"];
    return MarketingFactory;
}());
var EmployeeSupervisorFactory = (function () {
    function EmployeeSupervisorFactory($http) {
        this.$http = $http;
    }
    EmployeeSupervisorFactory.prototype.getAll = function (empID) {
        return this.$http.post(WsUrl + "/GetAllEligibleSupervisorsForEmployee", {
            empID: empID,
        });
    };
    EmployeeSupervisorFactory.$inject = ["$http"];
    return EmployeeSupervisorFactory;
}());
var PayCalendarFactory = (function () {
    function PayCalendarFactory($http) {
        this.$http = $http;
    }
    PayCalendarFactory.prototype.getAll = function () {
        return this.$http.post(WsUrl + "/GetAllPayCalendars" + OldApiReadOnlySession, {});
    };
    PayCalendarFactory.$inject = ["$http"];
    return PayCalendarFactory;
}());
var MetricValuesFactory = (function () {
    function MetricValuesFactory($http) {
        this.$http = $http;
    }
    MetricValuesFactory.prototype.getBusinessVerticals = function () {
        return this.$http.post(WsUrl + "/GetMetricValuesForBusinessVerticals", {});
    };
    MetricValuesFactory.prototype.getEmployeeClasses = function () {
        return this.$http.post(WsUrl + "/GetMetricValuesForEmployeeClasses", {});
    };
    MetricValuesFactory.$inject = ["$http"];
    return MetricValuesFactory;
}());
var ClosingUnitModifierFactory = (function () {
    function ClosingUnitModifierFactory($http) {
        this.$http = $http;
    }
    ClosingUnitModifierFactory.prototype.getAll = function () {
        return this.$http.post(WsUrl + "/GetAllClosingUnitModifier", {});
    };
    ClosingUnitModifierFactory.prototype.insert = function (c) {
        return this.$http.post(WsUrl + "/InsertClosingUnitModifier", {
            vertical: c.Vertical,
            employeeClass: c.EmployeeClass,
            minUnits: c.MinUnits,
            modifier: c.Modifier,
            startDt: c.StartDt,
            stopDt: c.StopDt,
            retroactive: c.Retroactive
        });
    };
    ClosingUnitModifierFactory.prototype.update = function (c) {
        return this.$http.post(WsUrl + "/UpdateClosingUnitModifier", {
            closingUnitModifierID: c.ClosingUnitModifierId,
            vertical: c.Vertical,
            employeeClass: c.EmployeeClass,
            minUnits: c.MinUnits,
            modifier: c.Modifier,
            startDt: c.StartDt,
            stopDt: c.StopDt,
            retroactive: c.Retroactive
        });
    };
    ClosingUnitModifierFactory.prototype.delete = function (id) {
        return this.$http.post(WsUrl + "/DeleteClosingUnitModifier", {
            closingUnitModifierID: id,
        });
    };
    ClosingUnitModifierFactory.$inject = ["$http"];
    return ClosingUnitModifierFactory;
}());
var LoanPullThruMinFactory = (function () {
    function LoanPullThruMinFactory($http) {
        this.$http = $http;
    }
    LoanPullThruMinFactory.prototype.getAll = function () {
        return this.$http.post(WsUrl + "/GetAllLoanPullThruMin", {});
    };
    LoanPullThruMinFactory.prototype.insert = function (c) {
        return this.$http.post(WsUrl + "/InsertLoanPullThruMin", {
            vertical: c.Vertical,
            minModUnits: c.MinModUnits,
            startDt: c.StartDt,
            stopDt: c.StopDt
        });
    };
    LoanPullThruMinFactory.prototype.update = function (c) {
        return this.$http.post(WsUrl + "/UpdateLoanPullThruMin", {
            LoanPullThruMinID: c.LoanPullThruMinID,
            vertical: c.Vertical,
            minModUnits: c.MinModUnits,
            startDt: c.StartDt,
            stopDt: c.StopDt
        });
    };
    LoanPullThruMinFactory.prototype.delete = function (id) {
        return this.$http.post(WsUrl + "/DeleteLoanPullThruMin", {
            LoanPullThruMinID: id,
        });
    };
    LoanPullThruMinFactory.$inject = ["$http"];
    return LoanPullThruMinFactory;
}());
var LoanPullThruMultiplierFactory = (function () {
    function LoanPullThruMultiplierFactory($http) {
        this.$http = $http;
    }
    LoanPullThruMultiplierFactory.prototype.getAll = function () {
        return this.$http.post(WsUrl + "/GetAllLoanPullThruMultiplier", {});
    };
    LoanPullThruMultiplierFactory.prototype.insert = function (lptm) {
        return this.$http.post(WsUrl + "/InsertLoanPullThruMultiplier", {
            vertical: lptm.Vertical,
            minPullThru: lptm.MinPullThru,
            multiplier: lptm.Multiplier,
            startDt: lptm.StartDt,
            stopDt: lptm.StopDt
        });
    };
    LoanPullThruMultiplierFactory.prototype.update = function (lptm) {
        return this.$http.post(WsUrl + "/UpdateLoanPullThruMultiplier", {
            LoanPullThruMultiplierID: lptm.LoanPullThruMultiplierID,
            vertical: lptm.Vertical,
            minPullThru: lptm.MinPullThru,
            multiplier: lptm.Multiplier,
            startDt: lptm.StartDt,
            stopDt: lptm.StopDt
        });
    };
    LoanPullThruMultiplierFactory.prototype.delete = function (id) {
        return this.$http.post(WsUrl + "/DeleteLoanPullThruMultiplier", {
            LoanPullThruMultiplierID: id,
        });
    };
    LoanPullThruMultiplierFactory.$inject = ["$http"];
    return LoanPullThruMultiplierFactory;
}());
var ConfigurationFactory = (function () {
    function ConfigurationFactory($http) {
        this.$http = $http;
    }
    ConfigurationFactory.prototype.get = function () {
        return this.$http.post(WsUrl + "/GetConfigurationInfo", {});
    };
    ConfigurationFactory.$inject = ["$http"];
    return ConfigurationFactory;
}());
var FeatureFlagFactory = (function () {
    function FeatureFlagFactory($http, csApiUrl) {
        this.$http = $http;
        this.csApiUrl = csApiUrl;
    }
    FeatureFlagFactory.prototype.getEnabled = function () {
        return this.$http.post(WsUrl + '/GetEnabledFeatureFlags', {});
    };
    FeatureFlagFactory.$inject = ["$http", "csApiUrl"];
    return FeatureFlagFactory;
}());
var AutoConfirmSAOsFactory = (function () {
    function AutoConfirmSAOsFactory($http, csApiUrl) {
        this.$http = $http;
        this.csApiUrl = csApiUrl;
    }
    AutoConfirmSAOsFactory.prototype.confirmSAODocs = function () {
        return this.$http.post(this.csApiUrl + "/sao-auto-confirm", {});
    };
    AutoConfirmSAOsFactory.$inject = ["$http", "csApiUrl"];
    return AutoConfirmSAOsFactory;
}());
var SettingFactory = (function () {
    function SettingFactory($http, csApiUrl) {
        this.$http = $http;
        this.csApiUrl = csApiUrl;
    }
    SettingFactory.prototype.get = function (internalCode) {
        return this.$http.get(this.csApiUrl + "/setting/" + internalCode);
    };
    SettingFactory.$inject = ["$http", "csApiUrl"];
    return SettingFactory;
}());
var AdditionalScenarioFactory = (function () {
    function AdditionalScenarioFactory($http, csApiUrl) {
        this.$http = $http;
        this.csApiUrl = csApiUrl;
    }
    AdditionalScenarioFactory.prototype.get = function (additionalScenarioId) {
        return this.$http.get(this.csApiUrl + "/additional-scenarios/" + additionalScenarioId);
    };
    AdditionalScenarioFactory.$inject = ["$http", "csApiUrl"];
    return AdditionalScenarioFactory;
}());
angular
    .module("LBACompenSafeSite.Factories", [])
    .service("BranchFactory", BranchFactory)
    .service("EmployeeFactory", EmployeeFactory)
    .service("LoanSourceFactory", LoanSourceFactory)
    .service("LoanTypeFactory", LoanTypeFactory)
    .service("LoanChannelFactory", LoanChannelFactory)
    .service("CurrentUserFactory", CurrentUserFactory)
    .service("CompanyFactory", CompanyFactory)
    .service("PayrollPeriodFactory", PayrollPeriodFactory)
    .service("AdjTypeFactory", AdjTypeFactory)
    .service("EmpAllocFactory", EmpAllocFactory)
    .service("EmpCommFactory", EmpCommFactory)
    .service("EmpOverrideFactory", EmpOverrideFactory)
    .service("BranchPayrollMenuFactory", BranchPayrollMenuFactory)
    .service("UserMsgFactory", UserMsgFactory)
    .service("CorporatePayrollMenuFactory", CorporatePayrollMenuFactory)
    .service("CompanyPayTimingFactory", CompanyPayTimingFactory)
    .service("DrawFactory", DrawFactory)
    .service("AutoDrawFactory", AutoDrawFactory)
    .service("CommissionFactory", CommissionFactory)
    .service("RegionFactory", RegionFactory)
    .service("RvpFactory", RvpFactory)
    .service("AddressStatesFactory", AddressStatesFactory)
    .service("DivisionManagerAccessFactory", DivisionManagerAccessFactory)
    .service("AreaManagerAccessFactory", AreaManagerAccessFactory)
    .service("CompensationFactory", CompensationFactory)
    .service("PositionFactory", PositionFactory)
    .service("TermRuleFactory", TermRuleFactory)
    .service("EmployeeLogFactory", EmployeeLogFactory)
    .service("DocsFactory", DocsFactory)
    .service("ExportDataFactory", ExportDataFactory)
    .service("SessionFactory", SessionFactory)
    .service("ProductionFactory", ProductionFactory)
    .service("PipelineFactory", PipelineFactory)
    .service("SocialMediaFactory", SocialMediaFactory)
    .service("LOSystemFactory", LOSystemFactory)
    .service("CompanyAccessSectionFactory", CompanyAccessSectionFactory)
    .service("AccessSectionFactory", AccessSectionFactory)
    .service("PurposeIndicatorFactory", PurposeIndicatorFactory)
    .service("LoanContactFactory", LoanContactFactory)
    .service("LoanFeeFactory", LoanFeeFactory)
    .service("LoanDocumentFactory", LoanDocumentFactory)
    .service("LoanFactory", LoanFactory)
    .service("StateFactory", StateFactory)
    .service("PardotExportFactory", PardotExportFactory)
    .service("MetricFactory", MetricFactory)
    .service("EmployeeNotesFactory", EmployeeNotesFactory)
    .service("FLSAStatusFactory", FLSAStatusFactory)
    .service("WageCategoryFactory", WageCategoryFactory)
    .service("FileUploadQueueFactory", FileUploadQueueFactory)
    .service("LoanTableMappingFactory", LoanTableMappingFactory)
    .service("FastFetchFactory", FastFetchFactory)
    .service("HeadcountRoleFactory", HeadcountRoleFactory)
    .service("RoleCategoryFactory", RoleCategoryFactory)
    .service("MarketingFactory", MarketingFactory)
    .service("EmployeeSupervisorFactory", EmployeeSupervisorFactory)
    .service("CompanyPayExpirationFactory", CompanyPayExpirationFactory)
    .service("CompanyPayExpirationTimingFactory", CompanyPayExpirationTimingFactory)
    .service("PayCalendarFactory", PayCalendarFactory)
    .service("MetricValuesFactory", MetricValuesFactory)
    .service("ClosingUnitModifierFactory", ClosingUnitModifierFactory)
    .service("LoanPullThruMinFactory", LoanPullThruMinFactory)
    .service("LoanPullThruMultiplierFactory", LoanPullThruMultiplierFactory)
    .service("ConfigurationFactory", ConfigurationFactory)
    .service("FeatureFlagFactory", FeatureFlagFactory)
    .service("AutoConfirmSAOsFactory", AutoConfirmSAOsFactory)
    .service("SettingFactory", SettingFactory)
    .service("HeldPayTranFactory", HeldPayTranFactory)
    .service("EmployeeRelationshipFactory", EmployeeRelationshipFactory)
    .service("CompanyBulkheadFactory", CompanyBulkheadFactory)
    .service("AdditionalScenarioFactory", AdditionalScenarioFactory);
